/* eslint-disable import/no-anonymous-default-export */
import { RouteObject } from "react-router-dom";
import {
  ACCESS_RIGHT,
  ACCESS_RIGHT_COMPANY_DETAILS, ACCESS_RIGHT_COMPANY_EMPLOYEE_ADD,
  ACCESS_RIGHT_COMPANY_EMPLOYEE_DETAILS,
  ACCESS_RIGHT_COMPANY_EMPLOYEE_EDIT,
  ACCESS_RIGHT_COMPANY_EMPLOYEE_GROUP_ADD,
  ACCESS_RIGHT_COMPANY_EMPLOYEE_GROUP_DETAILS
} from "../../constants/urls";

/** @type {import("react-router-dom").RouteObject[]} */
export default [
  {
    path: ACCESS_RIGHT,
    lazy: () => import("./routes/AccessRightCompanyList"),
  },
  {
    path: ACCESS_RIGHT_COMPANY_DETAILS,
    lazy: () => import("./routes/AccessRightCompanyDetails"),
  },

  {
    path: ACCESS_RIGHT_COMPANY_EMPLOYEE_DETAILS,
    lazy: () => import("./routes/AccessRightCompanyEmployeeDetails"),
  },
  {
    path: ACCESS_RIGHT_COMPANY_EMPLOYEE_ADD,
    lazy: () => import("./routes/AccessRightCompanyEmployeeAddEdit"),
  },
  {
    path: ACCESS_RIGHT_COMPANY_EMPLOYEE_EDIT,
    lazy: () => import("./routes/AccessRightCompanyEmployeeAddEdit"),
  },
  {
    path: ACCESS_RIGHT_COMPANY_EMPLOYEE_GROUP_DETAILS,
    lazy: () => import("./routes/AccessRightCompanyEmployeeGroupDetails"),
  },
  {
    path: ACCESS_RIGHT_COMPANY_EMPLOYEE_GROUP_ADD,
    lazy: () => import("./routes/AccessRightCompanyEmployeeGroupAddEdit"),
  },
] as RouteObject[];
